import { render, staticRenderFns } from "./CategoriesListButton.vue?vue&type=template&id=8e372dba&scoped=true&"
import script from "./CategoriesListButton.vue?vue&type=script&lang=js&"
export * from "./CategoriesListButton.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesListButton.vue?vue&type=style&index=0&id=8e372dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e372dba",
  null
  
)

export default component.exports